import React, { useContext, useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  Form,
  Table,
  Pagination,
  Offcanvas,
  InputGroup,
  Button,
  Row,
  Col,
} from "react-bootstrap";
import { FaPlus } from "react-icons/fa";
import { CiCalendar, CiClock1 } from "react-icons/ci";
import useMenuPermissions from "../../components/CustomHook/custompermission";
import Notauthorized from "../../components/Not-authorized/notauthorized";
// import { Calendar, Clock } from "react-bootstrap-icons";
import { UserContext } from "../../context/UserContextProvider";
import APIServicenew from "../../utils/APIGeneralService";
import Paginator from "../../components/common/Pagination";
import { months } from "moment";
import { capitalizeFirstLetter } from "../../utils/Helper";

const TargetAchievement = () => {
  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const authToken = process.env.REACT_APP_authToken;
  const { accessToken, logout } = useContext(UserContext);
  const headers = { "auth-token": authToken, authorization: accessToken };
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const limit = 10;
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const permissionscontext = useMenuPermissions("/admin/target-achievement");
  const [dataList, setDataList] = useState([]);
  const [count, setCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [showDt, setShowDt] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [searchTerm, setSearchTerm] = useState({
    name: "",
    status: "",
    month: "",
    year: "",
    product_id: "",
  });
  const [productList, setProductList] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [flag, setFlag] = useState(false);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage, flag]);

  useEffect(() => {
    handleProductList();
  }, []);
  const fetchData = async (page = 1) => {
    const skip = (page - 1) * limit;

    try {
      const response = await APIServices.get(
        `/admin/target/list?offset=${skip}&limit=${limit}&status=${searchTerm.status}&name=${searchTerm.name}&month=${searchTerm.month}&year=${searchTerm.year}&product_id=${searchTerm.product_id}`,
        headers
      );
      if (response?.status === 200) {
        const data1 = response?.data?.list || [];
        setDataList(data1);
        setCount(response?.data?.count);
        const totalItems = response?.data?.count || 0;
        setTotalCount(Math.ceil(totalItems / limit));
        setShow(false);
        setFlag(false)
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setDataList([]);
        setTotalCount(0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setDataList([]);
      setTotalCount(0);
    }
  };
  const handleProductList = async (page = 1) => {
    try {
      const response = await APIServices.get(
        `/admin/product/list?offset=0&limit=1000&sort_by=name&status=Active`,
        headers
      );
      if (response?.status === 200) {
        const data1 = response?.data?.list || [];
        setProductList(data1);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setProductList([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setProductList([]);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm({ ...searchTerm, [e.target.name]: e.target.value });
  };

  const resetDta = () => {
    setSearchTerm({
      name: "",
      status: "",
      month: "",
      year: "",
      product_id: "",
    });
    setShow(false);
  };
  return (
    <>
      {permissionscontext.view ? (
        <>
          <div className="momList_inner todo_list_inner Target_achievement_sec ">
            <div className="mom_header d-flex align-items-center justify-content-between mb-3">
              <h1 className="font_blue_18 font-600">{`Target Vs Achievement (${count})`}</h1>

              <ul className="d-flex align-items-center mom_filter">
                <li
                  className="d-flex align-items-center cursor-pointer"
                  onClick={() => setShow(true)}
                >
                  Filter By{" "}
                  <img
                    src="/images/Sort.svg"
                    className="img-fluid ms-2"
                    alt="Sort"
                  />
                </li>
                <li>
                  <button
                    className="btn red_button d-flex align-items-center"
                    onClick={() => navigate("/admin/add-target")}
                    disabled={!permissionscontext.add}
                  >
                    <FaPlus className="me-1" />
                    Add Target/Achievement
                  </button>
                </li>
              </ul>
            </div>

            <div className="todoList_table">
              <div className="table-responsive">
                <Table>
                  <thead className="table-dark">
                    <tr>
                      <th>Sr.No</th>
                      <th>Name</th>
                      <th>Target</th>
                      <th>Achievement</th>
                      <th>Product</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  {dataList && dataList?.length > 0 ? (
                    <>
                      <tbody>
                        {dataList &&
                          dataList?.map((user, index) => (
                            <tr key={user.id}>
                              <td>{(currentPage - 1) * limit + index + 1}</td>
                              <td>
                                <Link to={`/admin/target-details/${user.id}`}>
                                  <div className="d-flex align-items-center">
                                    {
                                      user?.profile_pic ?
                                        <img
                                          src={user.profile_pic}
                                          className="img-fluid me-2 table_user"
                                          alt={user.first_name}
                                          onError={(e) => (e.target.src = "/images/placeholder-img.jpg")}
                                        />
                                        :
                                        <img src="/images/placeholder-img.jpg"
                                          className='img-fluid me-2 table_user'
                                          alt="default img"
                                        />
                                    }
                                    <p className="textTransform">{user.fullname}</p>
                                  </div>
                                </Link>
                              </td>
                              <td>{user.target}</td>
                              <td>{user.achieved ?? "_"}</td>
                              <td className="textTransform">{user.product_name}</td>

                              <td>
                                <ul className="d-flex align-items-center justify-content-end gap-2">
                                  <li>
                                    <button
                                      disabled={!permissionscontext.view}
                                      style={{
                                        border: "none",
                                        background: "transparent",
                                        padding: 0,
                                        cursor: !permissionscontext.view
                                          ? "not-allowed"
                                          : "pointer",
                                        opacity: !permissionscontext.view
                                          ? 0.5
                                          : 1,
                                      }}
                                      onClick={() =>
                                        navigate(
                                          `/admin/target-details/${user.id}`
                                        )
                                      }
                                    >
                                      <img
                                        src="/images/Eye.svg"
                                        className={`img-fluid trash`}
                                        alt="eye"
                                      />
                                    </button>
                                  </li>
                                  {/* <li><img src="/images/Trash.svg" 
                                                className={`img-fluid trash ${!permissionscontext.delete ? "opacity-50 disabled" : ""}`}
                                                alt="trash" 
                                                style={{ cursor: permissionscontext.delete ? "pointer" : "not-allowed" }} 
                                                
                                                /></li> */}
                                  <li
                                    className={user.achieved ? "disabled" : ""}
                                    style={{
                                      pointerEvents: user.achieved
                                        ? "none"
                                        : "auto",
                                      opacity: user.achieved ? 0.5 : 1,
                                    }}
                                  >
                                    <button
                                      disabled={!permissionscontext.edit}
                                      style={{
                                        border: "none",
                                        background: "transparent",
                                        padding: 0,
                                        cursor: !permissionscontext.edit
                                          ? "not-allowed"
                                          : "pointer",
                                        opacity: !permissionscontext.edit
                                          ? 0.5
                                          : 1,
                                      }}
                                      onClick={() =>
                                        navigate(
                                          `/admin/update-targets/${user.id}`,
                                          {
                                            state: { row: user },
                                          }
                                        )
                                      }
                                    >
                                      <img
                                        src="/images/Pen.svg"
                                        className={`img-fluid pen`}
                                        alt="pen"
                                      />
                                    </button>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </>
                  ) : (
                    <>
                      <tbody>
                        <tr>
                          <td colSpan="6" className="border-0">
                            <div className="d-flex align-items-center justify-content-center mt-5">
                              <h4>Not Available</h4>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </>
                  )}
                </Table>
              </div>
            </div>
            {count > 10 && (

              <Paginator
                currentPage={currentPage}
                totalPages={totalCount}
                onPageChange={handlePageChange}
              />
            )}
          </div>

          <Offcanvas
            className="mom_filter"
            show={show}
            onHide={() => setShow(false)}
            placement="end"
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title className="font_blue_18 font-600">
                Filter By
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="pt-0">
              <Form className="filter_form">
                <div>
                  <label className="font_blue_14 font-500 mb-2">Name</label>
                  <Form.Control
                    type="text"
                    placeholder="Search Name..."
                    name="name"
                    value={searchTerm.name}
                    onChange={handleSearchChange}
                  />
                </div>
                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Label className="font_blue_14 font-500 mb-2">
                      Month
                    </Form.Label>
                    <Form.Select
                      name="month"
                      onChange={handleSearchChange}
                      value={searchTerm.month}
                    >
                      <option value="">Select Month</option>
                      {[
                        { name: "January", value: 1 },
                        { name: "February", value: 2 },
                        { name: "March", value: 3 },
                        { name: "April", value: 4 },
                        { name: "May", value: 5 },
                        { name: "June", value: 6 },
                        { name: "July", value: 7 },
                        { name: "August", value: 8 },
                        { name: "September", value: 9 },
                        { name: "October", value: 10 },
                        { name: "November", value: 11 },
                        { name: "December", value: 12 },
                      ].map((month) => (
                        <option key={month.value} value={month.value}>
                          {month.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>

                  <Col md={6}>
                    <Form.Label className="font_blue_14 font-500 mb-2">
                      Year
                    </Form.Label>
                    <Form.Select
                      name="year"
                      onChange={handleSearchChange}
                      value={searchTerm.year}
                    >
                      <option value="">Select Year</option>
                      {Array.from({ length: 80 }, (_, index) => {
                        const year = 2020 + index;
                        return (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </Col>
                </Row>

                <div>
                  <label className="font_blue_14 font-500 mb-2">
                    Product Name
                  </label>
                  <Form.Select name="product_id" value={searchTerm.product_id} onChange={handleSearchChange}>
                    <option value="">Select Product Name</option>
                    {productList?.map((item) => (
                      <option key={item.id} value={item.id}>
                        {capitalizeFirstLetter(item.name)}
                      </option>
                    ))}
                  </Form.Select>
                </div>
                <div>
                  <label className="font_blue_14 font-500 mb-2">Status</label>
                  <Form.Select
                    name="status"
                    value={searchTerm.status}
                    onChange={handleSearchChange}
                    aria-label="Select Status"
                  >
                    <option value="">Select Status</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </Form.Select>
                </div>

              </Form>
            </Offcanvas.Body>

            <div className="offcanvas-footer">
              <button
                className="btn blue_border"
                onClick={() => {
                  resetDta();
                  setFlag(true);
                }}
              >
                Clear
              </button>
              <button className="btn red_button" onClick={() => fetchData()}>
                Apply
              </button>
            </div>
          </Offcanvas>
        </>
      ) : (
        <Notauthorized />
      )}
    </>
  );
};

export default TargetAchievement;
